import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";

/**
 * PropagationSummaryCard — inline calm success card shown after a
 * governance action completes (Phase 4 directive #8).
 *
 *   "Voucher standards propagated successfully.
 *    125 organizations updated · 4 inherited overrides removed ·
 *    2 active break-glass exceptions remain"
 */
export const PropagationSummaryCard = ({ summary, displayName, onDismiss }) => {
    const { t } = useTranslation();
    if (!summary) return null;
    return (
        <div
            data-testid="ob-propagation-summary"
            className="ob-card p-5 space-y-2"
            style={{
                background: "rgba(16,185,129,0.06)",
                border: "1px solid rgba(16,185,129,0.20)",
            }}
        >
            <div className="flex items-center gap-3">
                <CheckCircle2 size={20} strokeWidth={1.5} style={{ color: "var(--ob-emerald)" }} aria-hidden="true" />
                <h3 className="text-base" style={{ color: "var(--ob-text-primary)", fontFamily: "Outfit, sans-serif" }}>
                    {t("ob.governance.propagation.title", { name: displayName || "" })}
                </h3>
            </div>
            <p className="text-sm pl-8" style={{ color: "var(--ob-text-secondary)" }}>
                {summary.plain_language || t("ob.governance.propagation.fallback")}
            </p>
            {onDismiss && (
                <div className="flex justify-end">
                    <button
                        type="button"
                        onClick={onDismiss}
                        className="text-xs hover:underline"
                        style={{ color: "var(--ob-text-tertiary)" }}
                        data-testid="ob-propagation-dismiss"
                    >
                        {t("common.dismiss", { defaultValue: "Dismiss" })}
                    </button>
                </div>
            )}
        </div>
    );
};
